var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"px-0"},[_c('EnsembleList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }